export class Moneda{
    NOMBRE:string="";//DESCRIPCION O NOMBRE DE LA MONEDA
    FACCOMPRA:number=1;//VALOR NUMERICO PARA LA COMPRA DE MONEDA 
    FACVENTA:number=1;//VALOR NUMERICO PARA LA VENTA DE MONEDA 
    OPERADORCOMPRA:boolean=false;//OPERADOR DEL FACTOR DE COMPRA FALSE=MULTIPLICACION, TRUE= DIVISION
    OPERADORVENTA:boolean=false;//OPERADOR DEL FACTOR DE VENTA FALSE=MULTIPLICACION, TRUE= DIVISION
}